import type { UserDto } from '@gap/backend/app-services/user/models/UserDto'
import type { Menu, MenuChildItem } from './MenuConfig'

/** The permission shape a menu item carries, without its optionality. */
export type MenuItemPermission = NonNullable<MenuChildItem['permission']>

/**
 * Whether the user has a Circle membership to sign in to Gap Academy with.
 * @param userData the signed-in user
 * @returns true when the user has a Circle id
 */
export const canSeeGapAcademy = (userData: UserDto.info): boolean => !!userData.circleId

/**
 * Filters menu sections to the items the viewer may see, dropping sections left with nothing in them.
 * @param params.sections the full menu, section by section
 * @param params.hasPermission the permission check each item is put through
 * @returns the sections to render, each holding only its visible items
 */
export function visibleMenu(params: { sections: Menu[], hasPermission: (permission: MenuItemPermission) => boolean }): Menu[] {
   const { sections, hasPermission } = params
   return sections
      .map(section => ({
         title: section.title,
         children: section.children.filter(item => !item.permission || hasPermission(item.permission)),
      }))
      .filter(section => section.children.length > 0)
}
